import React from "react";

const AttendanceChart = ({ present = 0, absent = 0 }) => {
  const data = [
    { name: "Present", value: present, fill: "#195de6" },
    { name: "Absent", value: absent, fill: "#dc2828" },
  ];

  return (
    <div>
      <div className="d-flex justify-content-around align-items-center gap-2 mt-2">
        {data.map((d) => (
          <div key={d.name} className="d-flex align-items-center gap-2">
            <span
              style={{
                backgroundColor: d.fill,
                height: "12px",
                width: "12px",
                borderRadius: "4px",
              }}
            ></span>
            <span>
              {d.name}: {d.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AttendanceChart;
